import { Button, ButtonProps } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

type DashedButtonProps = Omit<ButtonProps, 'variant'>;

export const DashedButton: React.FC<DashedButtonProps> = ({ sx, ...rest }) => {
    const addFieldBorderRadius = 1;
    const addFieldBorderStyle = {
        border: 1,
        borderColor: grey[400],
        borderRadius: addFieldBorderRadius,
        borderStyle: 'dashed',
    };
    return (
        <Button
            sx={{
                width: '100%',
                ...addFieldBorderStyle,
                ...sx,
            }}
            {...rest}
        ></Button>
    );
};
